import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'


 // GET LISTADO DE ACCESO POR MENU
 export const getAccesosUser = async (IdUser) => {
    const result = await PrivateInterceptor('IT/Users/Accesos/'+ IdUser, 'GET');
    return result;
 }

  // GET LISTADO DE ACCESO POR MENU
  export const getAccesosRol = async (IdRol) => {
     const result = await PrivateInterceptor('IT/Accesos/AccesosRoles/'+ IdRol, 'GET');
     return result;
  } 

// UPDATE LISTADO DE ACCESOS DE UN USUARIO
export const updateAccesoUser = async (data) => {
    const result = await PrivateInterceptor(`IT/Users/Accesos`, 'PUT', data);
    return result;
 }

 // UPDATE LISTADO DE ACCESOS DE UN USUARIO
export const updateAccesoRol = async (data) => {
   const result = await PrivateInterceptor(`IT/Users/Accesos/Rol`, 'PUT', data);
   return result;
}


 export const getPermisoCostosUser = async (idUser) => {
      const result = await PrivateInterceptor('IT/Users/PermisoCostos/'+ idUser, 'GET');
      return result;
 }
 export const getPermisoBotonesUser = async (idUser) => {
      const result = await PrivateInterceptor('IT/Users/PermisosBotones/'+ idUser, 'GET');
      return result;
 }